export default "__VITE_ASSET__7881c132__"